import { ToastrService } from 'ngx-toastr';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { CrmService } from './../../../../components/crm/crm.service';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ICellEditorParams } from 'ag-grid-community';
import { UpdateCellData, UpdateCellDataIntentToBuy } from '../ag-grid.model';
import { OperationId } from 'src/app/shared/model/enum';
import { AgGridService } from '../ag-grid.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

export class CurrentSelection{
  name:string=""
  colorCode:string=""
}
@Component({
  selector: 'app-intent-to-buy-editor',
  templateUrl: './intent-to-buy-editor.component.html',
  styleUrls: ['./intent-to-buy-editor.component.scss']
})
export class IntentToBuyEditorComponent implements OnInit,ICellEditorAngularComp {
  dropDownList: any[]=[];
  currentSelection = new CurrentSelection();
  // updateCellData= new UpdateCellData();
  updateCellData = new UpdateCellDataIntentToBuy();

  operationId=OperationId;
  active = false;
  params
  selectedValue: any;
  icon = './assets/SVGIcons/upIcon-arrow.svg'
  @ViewChild("mySelect") mySelect: ElementRef;
  @ViewChild('dropdown', { static: false }) dropdown!: NgbDropdown;
  private scrollListener: any;
  constructor(private crmService:CrmService,private agGridService:AgGridService,private toastr:ToastrService) { }
  agInit(params: ICellEditorParams<any, any>): void {
    this.params = params;
    this.selectedValue = params.value;
    if(this.params?.column?.colId == 'intentToBuyId'){
      this.currentSelection.name = params?.data?.intentToBuyName;
    }
    else if(this.params?.column?.colId == 'leadScoreId'){
      this.currentSelection.name = params?.data?.leadScoreName;
    }
    else if(this.params?.column?.colId == 'lineStatus'){
      this.currentSelection.name = params?.data?.lineStatus;
    }
    this.currentSelection.colorCode = params?.data?.intendToBuyColorCode;
    this.scrollHandle()
  }
  scrollHandle(){
    this.scrollListener = () => {
      if (this.dropdown && this.dropdown.isOpen()) {
        this.dropdown.close();
        this.active = false;
      }
    };

    this.params.api.addEventListener('bodyScroll', this.scrollListener);
  }
  getValue() {
    
  }
  isPopup?(): boolean {
    return
  }
  refresh(params: any): boolean {
    return true;
  }
  getPopupPosition?(): string {
    return
  }
  isCancelBeforeStart?(): boolean {
    return
  }
  isCancelAfterEnd?(): boolean {
    return
  }
  focusIn?(): void {
    return
  }
  focusOut?(): void {
   return
  }
  afterGuiAttached?(): void {
    return
  }

  ngOnInit(): void {
    let allDropDownData:any = this.crmService.dropdownAllList.getValue();
    switch (this.params?.column?.colId) {
      case 'intentToBuyId':
        this.dropDownList = allDropDownData?.intendToBuyList;
        this.updateCellData.saleStageId = this.params?.data?.saleStageId;
        break
      case 'leadScoreId':
        this.dropDownList = allDropDownData?.leadsList;
        this.updateCellData.saleStageId = this.params?.data?.saleStageId;
        break
      case 'offerScore':
        this.dropDownList = allDropDownData?.leadsList;
        this.updateCellData.saleStageId = this.params?.data?.saleStageId;
        break
      case 'lineStatus':
        this.dropDownList = [
           {
               "id": "0",
               "name": "Not Ready",
               "labelName": "lineStatus",
               "colorCode": "#000000",
               "isActive": true
           },
           {
               "id": "1",
               "name": "Ready",
               "labelName": "lineStatus",
               "colorCode": "#DE466D",
               "isActive": true
           }
          ];
        break
      default:
        this.dropDownList =  []
        break
    }
  }

      newOption: any;
  emptyDataSelection = {
    name: 'Select'
  };

  setCurrentSelection(option) {
    if(this.params?.column?.colId == 'offerScore'){
      this.currentSelection = option;
      this.currentSelection.name = option?.name
      return
    }
    let expanded = this.params.data.isExpandable;
    this.currentSelection = option;

    if (!this.updateCellData.companyIds) {
        this.updateCellData.companyIds = [];
    }
    this.updateCellData.companyIds.push(this.params?.data?.id);

    switch (this.params?.column?.colId) {
      case 'intentToBuyId':
        this.updateCellData.intentToBuyId = option.id;
        break
      case 'leadScoreId':
        this.updateCellData.leadScoreId = option.id;
        break
      case 'offerScore':
        this.updateCellData.leadScoreId = option.id;
        break
      default:
       
        break
    }
        this.crmService.updateRatingStatusLeadScoreIntendToBuy(this.updateCellData).subscribe(res => {
            res.response.isExpandable = expanded;

            const rowNode = this.params?.api?.getRowNode(String(this.params.rowIndex));
            rowNode.setData(res.response);

            this.toastr.success(res.message);
            this.params.api.refreshCells();
        });

    this.params.data.isExpandable = expanded;
    this.params.api.stopEditing(); 
}


}
